import React from 'react';
import './FloatingWhatsApp.css';

const sanitizePhoneNumber = (value) => String(value || '').replace(/[^\d]/g, '');

const FloatingWhatsApp = () => {
  const supportNumber = sanitizePhoneNumber(process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER);
  const supportMessage = process.env.REACT_APP_SUPPORT_WHATSAPP_MESSAGE ||
    'Assalamualaikum, saya perlukan bantuan berkenaan BTOP Wellness.';

  if (!supportNumber) return null;

  const whatsappUrl = `https://wa.me/${supportNumber}?text=${encodeURIComponent(supportMessage)}`;

  return (
    <a
      className="floating-whatsapp"
      href={whatsappUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Hubungi sokongan melalui WhatsApp"
    >
      <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <path d="M16 3.2c-7 0-12.7 5.4-12.7 12.1 0 2.2.6 4.3 1.8 6.1L3.3 28l6.9-1.7c1.8 1 3.8 1.5 5.9 1.5 7 0 12.7-5.4 12.7-12.1S23 3.2 16 3.2Zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.5-.3-4 1 1.1-3.8-.3-.5c-1-1.5-1.5-3.1-1.5-4.8C5.8 10 10.4 6 16 6s10.2 4.1 10.2 9.2S21.6 25 16 25Z" />
        <path d="M21.8 18.8c-.3-.1-1.8-.9-2.1-1-.3-.1-.5-.1-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.8-.7-1.4-1.6-1.6-1.9-.2-.3 0-.4.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-1-2.2-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.1.2 2.1 3.3 5.2 4.5.7.3 1.3.5 1.8.6.8.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.2-.6-.4Z" />
      </svg>
      <span>WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsApp;
